import { render, staticRenderFns } from "./TeamTaskHistory.vue?vue&type=template&id=e3fe0924&"
import script from "./TeamTaskHistory.vue?vue&type=script&lang=js&"
export * from "./TeamTaskHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports